/**
 * 講座の視聴進捗を表す値オブジェクト
 */
export class LectureProgress {
  private constructor(
    private readonly lectureId: string,
    private readonly completed: boolean,
    private readonly completedAt: Date | null
  ) {}

  /**
   * 新しい講座進捗を作成（未完了状態）
   */
  static create(lectureId: string): LectureProgress {
    return new LectureProgress(lectureId, false, null);
  }

  /**
   * 永続化データから復元
   */
  static reconstruct(
    lectureId: string,
    completed: boolean,
    completedAt: Date | null
  ): LectureProgress {
    return new LectureProgress(lectureId, completed, completedAt);
  }

  /**
   * 完了状態にする（新しいインスタンスを返す）
   */
  markAsCompleted(): LectureProgress {
    if (this.completed) {
      return this; // すでに完了している場合はそのまま返す
    }
    return new LectureProgress(this.lectureId, true, new Date());
  }

  /**
   * 視聴完了しているか判定
   */
  isCompleted(): boolean {
    return this.completed;
  }

  // ゲッター
  getLectureId(): string {
    return this.lectureId;
  }

  getCompletedAt(): Date | null {
    return this.completedAt;
  }

  /**
   * 永続化用のデータに変換
   */
  toData(): {
    lectureId: string;
    completed: boolean;
    completedAt: string | null;
  } {
    return {
      lectureId: this.lectureId,
      completed: this.completed,
      completedAt: this.completedAt ? this.completedAt.toISOString() : null,
    };
  }

  /**
   * 等価性判定
   */
  equals(other: LectureProgress): boolean {
    if (!(other instanceof LectureProgress)) {
      return false;
    }
    return (
      this.lectureId === other.lectureId && this.completed === other.completed
    );
  }
}
